<template>
  <div class="location-form">
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitLocation">
            <b-form-row>
              <div class="form-group col-12">
                <label for="location-reference" v-translate>Location Name/Reference</label>
                <div class="input-group">
                  <b-form-input v-model="location.reference"
                    id="location-reference"
                    type="text"
                    style="font-size: 2rem"
                    required
                  ></b-form-input>
                </div>
              </div>
              <div class="form-group col-sm-8">
                <label for="location-address" v-translate>Address</label>
                <div class="input-group" v-if="!formatted_address">
                  <div class="input-group">
                    <address-autocomplete ref="addressAutocomplete" @selected="checkLocationPlace" :minCharacter="4" required />
                  </div>
                  <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
                </div>
                <p v-else>
                  {{formatted_address}}
                  <b-button variant="danger" size="sm" @click="addressAcInput = ''; formatted_address = ''; location.place_id = null" class="px-1 py-0">✕</b-button>
                </p>
                <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header @hide="$refs.pickPlaceMap.pickPlace(0, 0)">
                  <place-picker ref="pickPlaceMap" @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
                </b-modal>
              </div>
              <div class="form-group col-sm-4">
                <label for="location-address_extra" v-translate>Floor, door, etc.</label>
                <div class="input-group">
                  <b-form-input id="location-address_extra" v-model="location.address_extra" class="col-12 form-control" />
                </div>
              </div>
              <div class="form-group col-6">
                <label for="location-contact" v-translate>Contact Name</label>
                <div class="input-group">
                  <b-form-input id="location-contact" v-model="location.contact" class="col-12 form-control" />
                </div>
              </div>
              <div class="form-group col-6" v-if="type === 'warehouses'">
                <label for="location-country" v-translate>Country</label>
                <b-form-select id="location-country" v-model="location.country_iso_code" :options="this.countries.map(x => { return {value: x.iso_code, text: x.name} })">
                  <template slot="first">
                    <option :value="null">Select Country</option>
                  </template>
                </b-form-select>
              </div>
              <div class="form-group col-sm-6">
                <label for="location-email" v-translate>Contact Email</label>
                <div class="input-group">
                  <b-form-input id="location-email" v-model="location.email" class="col-12 form-control" />
                </div>
              </div>
              <div class="form-group col-sm-6">
                <label for="location-phone" v-translate>Contact Phone</label>
                <div class="input-group">
                  <cleave ref="locationPhone" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="col-12 form-control" v-model="location.phone" autocomplete="nope"></cleave>
                </div>
              </div>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <h4 class="mb-3" v-translate>Business Hours</h4>
                <b-row v-for="(day, i) in schedule" :key="i" class="mb-3">
                  <b-col lg="2" class="align-self-center">
                    {{ day.dayName }}
                  </b-col>
                  <b-col lg="10">
                    <b-form-select v-model="location.schedule[i]['businessHours'][0]['from']" :options="timeSlots"
                    :required="location.schedule[i]['businessHours'][0]['to'] !== '' && location.schedule[i]['businessHours'][0]['to'] !== null"
                    style="width: auto; display: inline-block">
                      <template slot="first">
                        <option :value="null">--:--</option>
                      </template>
                    </b-form-select>
                    <translate translate-context="fromHourToHour">to</translate>
                    <b-form-select v-model="location.schedule[i]['businessHours'][0]['to']" :options="timeSlots"
                    :required="location.schedule[i]['businessHours'][0]['from'] !== '' && location.schedule[i]['businessHours'][0]['from'] !== null"
                    style="width: auto; display: inline-block">
                      <template slot="first">
                        <option :value="null">--:--</option>
                      </template>
                    </b-form-select>
                    <translate translate-context="fromHourToHourAndFromHourToHour">and</translate>
                    <b-form-select v-model="location.schedule[i]['businessHours'][1]['from']" :options="timeSlots"
                    :required="location.schedule[i]['businessHours'][1]['to'] !== '' && location.schedule[i]['businessHours'][1]['to'] !== null"
                    style="width: auto; display: inline-block">
                      <template slot="first">
                        <option :value="null">--:--</option>
                      </template>
                    </b-form-select>
                    <translate translate-context="fromHourToHour">to</translate>
                    <b-form-select v-model="location.schedule[i]['businessHours'][1]['to']" :options="timeSlots"
                    :required="location.schedule[i]['businessHours'][1]['from'] !== '' && location.schedule[i]['businessHours'][1]['from'] !== null"
                    style="width: auto; display: inline-block">
                      <template slot="first">
                        <option :value="null">--:--</option>
                      </template>
                    </b-form-select>
                    <b-button class="px-3" size="sm" variant="primary" @click="replicateToMonToFrid" v-if="i === 0" :disabled="!location.schedule[0]['businessHours'][0].from || !location.schedule[0]['businessHours'][0].to" v-translate>
                      Copy from M to F
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col class="form-actions">
                <b-button type="submit" variant="primary" size="lg" v-translate>Save Location</b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
import Cleave from 'vue-cleave'
import PlacePicker from '@/components/PlacePicker'

export default {
  name: 'LocationForm',
  components: {
    AddressAutocomplete,
    Cleave,
    PlacePicker
  },
  props: {
    location: {
      type: Object,
      default: function () {
        return {
          id: null,
          reference: null,
          place_id: null,
          phone: '',
          address_extra: '',
          schedule: [],
          company_id: null,
          country_iso_code: null
        }
      }
    },
    type: {
      type: String,
      default: 'warehouses'
    }
  },
  data() {
    return {
      schedule: [],
      formatted_address: '',
      dismissSecs: 10,
      dismissCountDown: 0,
      eventAreas: [],
      timeSlots: Array(24 * 2 + 1).fill(0).map((_, i) => {
        return {
          text: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1'),
          value: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1')
        }
      })
    }
  },
  watch: {
    'location.phone': {
      handler(val) {
        if (val.length > 0 && val.indexOf('+') === -1) {
          this.$refs.locationPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix + val.replace(/\s/g, ''))
        } else if (val.length === 0) {
          this.$refs.locationPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
        } else {
          this.$refs.locationPhone.cleave.setRawValue(val.replace(/\s/g, ''))
        }
      },
      deep: true
    },
    'location.place_id': {
      handler(val, oldVal) {
        if (val && !oldVal) {
          if (this.location.place_id) {
            this.$http.get(this.$appConfig.api.baseUrl + 'places/' + this.location.place_id)
              .then(response => {
                this.formatted_address = response.data.formatted_address
              })
          }
        }
      },
      deep: true
    }
  },
  mixins: [AddressMixins],
  created() {
    this.fetchCountries()
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let country = window.country || 'AR'
      if (this.location.place_id) {
        this.$http.get(this.$appConfig.api.baseUrl + 'places/' + this.location.place_id)
          .then(response => {
            this.formatted_address = response.data.formatted_address
          })
      }
      const companyMomentLocale = this.moment.localeData(window.countries.find(x => x.iso_code === country).front_config.i18n.moment)
      let companyLocaleWeekdays = [...companyMomentLocale.weekdays()]
      // reorder weekdays to force start on Monday
      companyLocaleWeekdays.push(companyLocaleWeekdays.shift())
      for (let i = 0; i < companyLocaleWeekdays.length; i++) {
        this.schedule.push({
          dayName: companyLocaleWeekdays[i].charAt(0).toUpperCase() + companyLocaleWeekdays[i].slice(1),
          businessHours: [
            {
              from: null,
              to: null
            },
            {
              from: null,
              to: null
            }
          ]
        })
      }
      this.location.schedule = this.mergeSchedule({...this.schedule}, {...this.location.schedule}) // {...this.schedule, ...this.location.schedule}
      if (!this.location.id) {
        this.location.company_id = this.$store.getters.profile.company_id
      }
      if (this.location.phone.length > 0 && this.location.phone.indexOf('+') === -1) {
        this.$refs.locationPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix + this.location.phone.replace(/\s/g, ''))
      } else if (this.location.phone.length === 0) {
        this.$refs.locationPhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
      } else {
        this.$refs.locationPhone.cleave.setRawValue(this.location.phone.replace(/\s/g, ''))
      }
    },
    mergeSchedule(...objects) {
      const isObject = obj => obj && typeof obj === 'object'

      return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach(key => {
          const pVal = prev[key]
          const oVal = obj[key]

          if (isObject(pVal) && isObject(oVal)) {
            prev[key] = this.mergeSchedule(pVal, oVal)
          } else {
            prev[key] = oVal
          }
        })

        return prev
      }, {})
    },
    async checkLocationPlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.location.place_id = this.theCheckedAddress.id
          this.formatted_address = this.theCheckedAddress.formatted_address
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setPlacePicked(place) {
      this.formatted_address = place.formatted_address
      this.location.place_id = place.id
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    },
    replicateToMonToFrid() {
      for (let i = 1; i < this.schedule.length - 2; i++) {
        this.location.schedule[i].businessHours = []
        for (let n = 0; n < this.schedule[0].businessHours.length; n++) {
          this.location.schedule[i].businessHours.push({...this.location.schedule[0].businessHours[n]})
        }
      }
    },
    submitLocation() {
      if (!this.location.id) {
        delete this.location.id
        delete this.location.place
        this.location.schedule = Object.values(this.location.schedule)
        this.$http.post(this.$appConfig.api.baseUrl + this.type, this.location)
          .then(response => {
            this.emitSuccess()
          })
      } else {
        let theId = this.location.id
        delete this.location.id // Needed to avoid API missunderstanding within Company ID
        delete this.location.created_at
        delete this.location.updated_at
        delete this.location.deleted_at
        delete this.location.place
        this.location.schedule = Object.values(this.location.schedule)
        this.$http.patch(this.$appConfig.api.baseUrl + this.type + '/' + theId, this.location)
          .then(response => {
            this.$parent.fetchWarehouse()
            this.emitSuccess()
          })
      }
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    closeModal(id) {
      this.$root.$emit('bv::hide::modal', id)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
